import Cases 		from "./Cases";
import Messages from "./Messages";

export default {
	Cases,
	Messages
};
